import {
    createParser,
    DXFParserSnippet,
    Identity
} from '../shared/parserGenerator';
import DxfArrayScanner, { ScannerGroup } from '../DxfArrayScanner';
import isMatched from '../shared/isMatched';
import type { DxfTable } from './types';
import parseBlockRecordTable from './blockRecord/parser';
import parseDimStyle from './dimStyle/parser';
import parseLayerTable from './layer/parser';
import parseLTypeTable from './ltype/parser';
import parseStyleTable from './style/parser';
import parseVPortTable from './vport/parser';

const TableParsers = {
    BLOCK_RECORD: parseBlockRecordTable,
    DIMSTYLE: parseDimStyle,
    LAYER: parseLayerTable,
    LTYPE: parseLTypeTable,
    STYLE: parseStyleTable,
    VPORT: parseVPortTable,
};

const CommonTableParserSnippets: DXFParserSnippet[] = [
    {
        code: 70,
        name: 'maxNumberOfEntries',
        parser: Identity,
    },
    {
        code: 100,
        name: 'subclassMarker',
        parser: Identity,
    },
    {
        code: 330,
        name: 'ownerObjectId',
        parser: Identity,
    },
    {
        // ACAD_XDICTIONARY, ignore
        code: 102,
    },
    {
        code: 360,
        isMultiple: true,
    },
    {
        code: 102,
    },
    {
        code: 5,
        name: 'handle',
        parser: Identity,
    },
    {
        code: 2,
        name: 'name',
        parser: Identity,
    },
];

const parseCommonTable = createParser(CommonTableParserSnippets);

export default function parseTables(curr: ScannerGroup, scanner: DxfArrayScanner) {
    const tables = {} as any;
    let current = curr;

    while (!isMatched(current, 0, 'EOF')) {
        if (isMatched(current, 0, 'ENDSEC')) break;

        if (isMatched(current, 0, 'TABLE')) {
            current = scanner.next();

            const table = { entries: [] as any[] } as DxfTable<any>;
            parseCommonTable(current, scanner, table);
            tables[table.name] = table;
        }

        if (isMatched(current, 0) && !isMatched(current, 0, 'ENDTAB')) {
            const name = current.value;
            current = scanner.next();

            // @ts-ignore
            const parseTable = TableParsers[name];
            if (parseTable) {
                const record = {} as any;
                parseTable(current, scanner, record);
                tables[name]?.entries.push(record);
            } else {
                console.warn(`parseTable: Invalid table name '${name}'`);
                current = scanner.next();
            }
        }

        current = scanner.next();
    }

    return tables;
}
